import React, { Component } from 'react'
import { post } from '../../utils/networking'
import {
    Route,
    NavLink,
    HashRouter
} from "react-router-dom";
import Footer from '../footer'
import Header from '../header'
import GeneralSetting from './general'
import ServiceSetting from './service'
import FacilitySetting from './facility'
import BlogList from './blog/list'
import CreateBlog from './blog/create'
import UpdateBlog from './blog/update'
import { BrowserRouter } from 'react-router-dom'
import * as Notification from '../../notification'
import $ from 'jquery'
import './style.css'

export default class Partner extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isShowChangePass: false
        }
    }

    passwordUpdate() {
        Notification.hide();
        var newPass = {
            oldPassword: this.refs.old_pass.value,
            newPassword: this.refs.new_pass.value,
            confirmPassword: this.refs.re_pass.value
        }
        if (newPass.oldPassword === "" || newPass.newPassword === "" || newPass.confirmPassword === "") {
            if (newPass.oldPassword === "")
                Notification.show($("#old_pass"), "Empty", "fail", "1");
            if (newPass.newPassword === "")
                Notification.show($("#new_pass"), "Empty", "fail", "1");
            if (newPass.confirmPassword === "")
                Notification.show($("#re_pass"), "Empty", "fail", "1");
            Notification.show($("#change_pass_submit"), "Please fill out all fields.", "fail", "0");
        }
        else {
            if (newPass.newPassword == newPass.confirmPassword) {

                $("#change_pass_submit").html("<i class='fa fa-spinner fa-pulse'></i> Waiting...");
                post('user/changePassword', newPass, "partner", result => {
                    Notification.show($("#change_pass_submit"), "Your password has been change.", "success", "0");
                    $("#change_pass_submit").html("Save Password");
                }, errors => {
                    Notification.show($("#change_pass_submit"), errors.errors[0], "fail", "0");
                    $("#change_pass_submit").html("Save Password");
                })

            }
            else {
                Notification.show($("#re_pass"), "Password doesn't match.", "fail", "1");
            }
        }

    }

    render() {
        let {
            isShowChangePass
        } = this.state;
        return (
            <BrowserRouter>
                <div id="user_page" className="partner_page">
                    <div className="user_header">
                        <p className="user_header_1">Partner setting</p>
                        <p className="user_header_2">Set Preferences, Track Rewards, Write Reviews and more!</p>
                        <div>
                            <span className="change_password_bt" onClick={() => this.setState({ isShowChangePass: true })}>Change your password</span>
                        </div>
                    </div>
                    <div className="user_detail">
                        <div className="column left_column">
                            <ul className="left_menu">
                                <li>
                                    <NavLink to="/partner">
                                        <i className="fas fa-cogs" aria-hidden="true"></i>
                                        <p>General</p>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/partner/setting/services">
                                        <i className="fas fa-boxes" aria-hidden="true"></i>
                                        <p>Update Services</p>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/partner/setting/facility">
                                        <i className="fas fa-heart" aria-hidden="true"></i>
                                        <p>Update Facilities</p>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/partner/setting/blog-list">
                                        <i className="fab fa-blogger-b" aria-hidden="true"></i>
                                        <p>Blogs</p>
                                    </NavLink>
                                </li>
                            </ul>
                        </div>
                        <div className="column midle_column">
                            <Route exact path="/partner/setting/services" component={ServiceSetting} />
                            <Route exact path="/partner/setting/facility" component={FacilitySetting} />
                            <Route exact path="/partner/setting/blog-list" component={BlogList} />
                            <Route exact path="/partner/setting/blog-create" component={CreateBlog} />
                            <Route exact path="/partner/setting/blog-update/:id" component={UpdateBlog} />
                            <Route exact path="/partner" component={GeneralSetting} />
                        </div>
                        {/* <div className="column right_column">
                            <div className="points-sidebar">
                                <fieldset className="points_earned">
                                    <legend><i className="fa fa-usd" aria-hidden="true"></i></legend>
                                    <p className="points_value">0</p>
                                    <p className="message">POINTS EARNED</p>
                                </fieldset>
                                <div className="progress_round">
                                    <div className="level_1">$25</div>
                                    <div className="level_2">$50</div>
                                    <div className="level_3">$100</div>
                                </div>
                                <a className="back_to_earn" href="#"Start earning points</NavLink>
                                <button className="rewards_button">
                                    Redeem Your Points
                                </button>
                            </div>
                        </div> */}
                    </div>
                    {
                        (isShowChangePass) ? <div className="password_update_form_partner">
                            <div className="form">
                                <div className="form_header">
                                    <span>Change Password</span>
                                    <i className="fa fa-times" aria-hidden="true" onClick={() => this.setState({ isShowChangePass: false })}></i>
                                </div>
                                <div className="form_detail">
                                    <div id="old_pass">
                                        <input type="password" ref="old_pass" placeholder="Old Password" />
                                    </div>
                                    <div id="new_pass">
                                        <input type="password" ref="new_pass" placeholder="New Password" />
                                    </div>
                                    <div id="re_pass">
                                        <input type="password" ref="re_pass" placeholder="Re-enter New Password" />
                                    </div>
                                    <div className="submit">
                                        <button id="change_pass_submit" onClick={this.passwordUpdate.bind(this)}>Save Password</button>
                                    </div>
                                </div>
                            </div>
                        </div> : ""
                    }
                </div>
            </BrowserRouter>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/partner/index.js